import React from 'react';

const ContentContainer = ({ children }) => {
    return (
        <div className="row">
            <div className="col s12 m12 l12">
                <div className="card card-default">
                    <div className="card-content">
                        <div className="row">
                            <div className="col s12">
                                { children }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentContainer;